import { Component } from '@angular/core';

@Component({
  selector: 'unh-side-menu-content',
  styleUrls: ['./side-menu-content.component.scss'],
  template: `
    <div class="side-menu-content">
      <ng-content></ng-content>
    </div>
  `
})
export class SideMenuContentComponent {}
